import {
  storeUserAgreementsStatus,
  storeOverallAgreements,
  storeTopAgreementsDialogIsOpen,
} from "actions"
import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

const useAgreements = () => {
  const dispatch = useDispatch()

  return {
    overallAgreements: useSelector((state) => state.overallAgreements),
    storeOverallAgreements: useCallback(
      (overallAgreements) =>
        dispatch(storeOverallAgreements({ overallAgreements })),
      [dispatch]
    ),
    storeUserAgreementsStatus: useCallback(
      (userAgreementStatus) =>
        dispatch(storeUserAgreementsStatus(userAgreementStatus)),
      [dispatch]
    ),
    storeTopAgreementsDialogIsOpen: useCallback(
      (topAgreementsDialogIsOpen) =>
        dispatch(storeTopAgreementsDialogIsOpen({ topAgreementsDialogIsOpen })),
      [dispatch]
    ),
  }
}

export default useAgreements
